import React, { useEffect, useState } from "react";
import ApplyModal from "../components/ApplyModal";

const EVT = "kiki:open-apply-modal";

// Decoupled from React context so any caller can reliably open the modal.
// Pass a course title string to pre-fill the course field.
export function useApplyModal() {
  return {
    openApply: (course) =>
      window.dispatchEvent(
        new CustomEvent(EVT, { detail: { course: typeof course === "string" ? course : undefined } })
      ),
  };
}

export function ApplyModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [course, setCourse] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setCourse(e.detail?.course || null);
      setOpen(true);
    };
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);

  return (
    <>
      {children}
      <ApplyModal open={open} onClose={() => setOpen(false)} defaultCourse={course} />
    </>
  );
}
